
import { defineComponent } from "vue";

export default defineComponent({
  props: ["data", "value"]
});
